export default "__VITE_ASSET__DNi3wZ8H__"